import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { OfferSession } from 'app/shared/models/class/session/session';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { ImgOfferDefaultService } from 'app/shared/services/img-offer-default/img-offer-default.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { SessionBasketService } from 'app/shared/services/session-basket/session-basket.service';
import { SessionService } from 'app/shared/services/session/session.service';

interface DialogData {
  clubCode: string;
  basket: FullOffer[];
  customerKey: number;
}

@Component({
  selector: 'app-open-dialog-add-offer-counter',
  templateUrl: './open-dialog-add-offer-counter.component.html',
  styleUrls: ['./open-dialog-add-offer-counter.component.scss']
})
export class OpenDialogAddOfferCounterComponent implements OnInit {

  searchForm: UntypedFormGroup;
  valueInput: string;
  userConnected: InfosUser;
  offers: FullOffer[];
  offersFiltered: FullOffer[] = [];
  color: ThemePalette = 'primary';
  offerPreview: FullOffer;
  sessions: OfferSession[];
  basket: FullOffer[] = [];
  clubCode: any;
  isLoading = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private offerService: OfferService,
    private authService: AuthService,
    public dialogRef: MatDialogRef<OpenDialogAddOfferCounterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private sessionService: SessionService,
    private route: ActivatedRoute,
    private imgOfferDefault: ImgOfferDefaultService,
    private sessionBasketService: SessionBasketService,
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.initComponent();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  applyFilter(filterValue: string): void {
    this.valueInput = filterValue.trim().toLowerCase();
    this.offersFiltered = this.offers.filter(o => o.offerName.toLowerCase().indexOf(this.valueInput) !== -1);

    this.offersFiltered?.length ?
      this.changeOfferPreview(this.offersFiltered[0]) :
      this.changeOfferPreview(this.offers[0]);
  }

  resetSearch(): void {
    this.valueInput = '';
    this.f.keyword.reset();
    this.offersFiltered = [];
    this.changeOfferPreview(this.offers[0]);

  }

  // getImgUrl(offer: FullOffer): string {
  //   // return !offer.image.includes('data') ? `${environment.apiUrl}/images/${offer.image}` : this.imgOfferDefault.imgDefault;
  // }

  changeOfferPreview(offer: FullOffer): void {
    this.offerPreview = offer;
    this.getSessionByClub(offer);
  }

  addOrDelteToBasket(offer: FullOffer, event?): void {

    const itemOffer = this.offers.find(o => o.offerKey === offer.offerKey);
    const indexBasket = this.basket.findIndex(o => o.offerKey === offer.offerKey);

    if (event && event.checked) {
      // this.basket.push(itemOffer);
      this.sessionBasketService.addInMyBasket(this.data.customerKey, offer.offerKey).subscribe({
        next: (sessions: FullOffer[]) => {
          this.basket = sessions;
        }
      });
    }
    if (indexBasket !== -1) {
      this.basket.splice(indexBasket, 1);
      this.sessionBasketService.deleteSessionBasketInMyBasket(this.data.customerKey, +offer.sessionBasketKey).subscribe({
        next: () => { }
      });
    }


    const offers = [...this.offers];

    this.basket?.forEach(offerBasket => {
      const index = offers.findIndex(o => o?.offerKey === offerBasket?.offerKey);
      if (index !== -1) {
        offers.splice(index, 1);
      }
    });

    this.offerPreview = offers[0];
    this.getSessionByClub(this.offerPreview);
  }


  isInInBasket(offer: FullOffer): boolean {
    const index = this.basket.findIndex(o => o.offerKey === offer.offerKey);
    return index !== -1 ? false : true;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }


  private getOffer(clubCode: string): void {
    this.isLoading = true;
    this.offerService.getOfferByClub(clubCode).subscribe({
      next: offers => {
        this.offers = offers.filter(o => o.isActive && !o.isExternalOffer);
        this.offerPreview = this.offers[0];
        this.getSessionByClub(this.offerPreview);
      }
    });
  }
  private getSessionByClub(offer: FullOffer): void {
    this.sessionService.getSessionByOffer(offer?.offerKey).subscribe({
      next: sessions => {
        this.sessions = sessions;
        this.isLoading = false;
      }
    });
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
    this.basket = this.data.basket;
    this.clubCode = this.route.snapshot.queryParams.clubCode && this.userConnected.role === 'admin' ?
      this.route.snapshot.queryParams.clubCode : this.userConnected.club_code;

    this.getOffer(this.clubCode);
  }

  get f() {
    return this.searchForm.controls;
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }

}
